import React, { useEffect, useRef, useState } from "react";
import transfercase from "../../../../../assets/image/category/transfercase.webp";
import { FaLongArrowAltRight } from "@react-icons/all-files/fa/FaLongArrowAltRight";
import { FaCheck } from "@react-icons/all-files/fa/FaCheck";
import { FaArrowRight } from "@react-icons/all-files/fa/FaArrowRight";
import transfercase1 from "../../../../../assets/image/services/transfercase1.webp";
import transfercase2 from "../../../../../assets/image/services/transfercase2.webp";
import transfercase3 from "../../../../../assets/image/services/transfercase3.webp";
import transfercase4 from "../../../../../assets/image/services/transfercase4.webp";
import { Link } from "react-router-dom";
import check from "../../../../../assets/image/check.png";
import MyButton from "../../utils/Button/MyButton";
export default function TransferCase() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    // Trigger animation after component mounts
    setTimeout(() => setIsVisible(true), 100);
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.1 }
    );
  }, []);
  return (
    <div className="overflow-hidden">
      {/*  transfer Case Services*/}

      <div className="text-black ">
        {/* Image Column (5/12) */}
        <div className="lg:col-span-5 md:col-span-1 relative flex items-center ">
          <img
            className=" w-full md:h-[25rem] h-[20rem] object-cover lg:h-[30rem] "
            src={transfercase}
            alt="transfer case"
          />
          <div class="absolute inset-0 bg-gradient-to-t from-[#2770ab]/70 to-transparent"></div>
          <div className="absolute inset-0 mb-20 flex items-center justify-center text-white text-cente ">
            <h3
              className={`text-white text-center font-bold absolute lg:text-[3.6rem] md:text-[2.4rem] text-2xl  text-[1.8rem]
           transition-all duration-[4000ms] ease-in-out
                ${isVisible ? "opacity-100" : "opacity-0"}
              `}
            >
              Transfer Case & Differential Services
            </h3>
          </div>
          <div
            className={`w-full flex items-center lg:mt-8 md:mt-4 mt-7 absolute inset-0 justify-center
           transition-all duration-[950ms] delay-1000 ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
          >
            <Link to="/contact-us">
              {/* <button className="p-2 rounded text-orange-500 bg-orange-500 text-white cursor-pointer">
                Book Now
              </button> */}
              <MyButton
                text=" Case & Differential Services"
                className="bg-orange-500 text-white  py-[12px] rounded-full text-base sm:text-lg md:text-xl font-bold transform transition-transform duration-500 hover:scale-105 shadow-md"
              />
            </Link>
          </div>
        </div>

        {/* Content Column (7/12) */}
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-[25px] lg:px-[11%] ">
          <div className="container mx-auto px-6 max-w-4xl  text-center ">
            <p className="text-[1.3rem] lg:block md:block hidden text-gray-700 mb-6 leading-relaxed">
              Your vehicle’s drivetrain depends on the transfer case and
              differentials to distribute power effectively between the wheels.
              These essential components ensure smooth handling, stability, and
              traction—especially in varying road conditions.
            </p>
            <p className="text-[1.3rem] text-gray-700 mb-6   leading-relaxed">
              When these parts begin to fail, you may notice vibrations, unusual
              noises, or reduced performance. Left unchecked, the damage can
              lead to costly repairs. At Vancouver Auto Parts, we provide expert
              diagnostics and high-quality replacement parts to keep your
              drivetrain running strong.
            </p>

            {/* 
            <ul className="ps-1">
              {[
                'Difficulty engaging or staying in 4WD',
                'Unusual grinding or whining noises',
                'Fluid leaks under the vehicle',
                '4WD warning lights on the dashboard',
                'Uneven tire wear',
                'Stiff or difficult steering',
              ].map((item, index) => (
                <li key={index} className="hover:text-blue-900 flex items-center mb-1 text-lg">
                  <span className="h-5 w-5 flex items-center justify-center bg-blue-900 inline-block rounded-full me-2">
                    <FaCheck className="text-white p-0.5" />
                  </span>
                  {item}
                </li>
              ))}
            </ul> */}
            <div
              className={`
           transition-all duration-[950ms] delay-[2500ms] ease-out
                ${
                  isVisible
                    ? "-translate-y-0 opacity-100"
                    : "translate-y-5 opacity-0"
                }
              `}
            >
              <Link to="/contact-us">
                {/* <button className="p-2 rounded text-white bg-orange-500 cursor-pointer flex items-center">
                  Book Now <FaArrowRight className="ml-2" />
                </button> */}

                <MyButton
                  text="Book Now"
                  className="mx-auto transform transition-transform duration-500 hover:scale-105"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-[#EFF6FF]">
        <div className="py-[30px] container ">
          <h1 className="text-blue-900 font-bold lg:text-[3.1rem]  md:text-4xl text-[1.7rem] text-center mb-3">
            Drivetrain Diagnostics You Can Trust
          </h1>
          <p className="mb-3 lg:font-normal text-[1.35rem] text-center lg:mt-5 lg:px-[7%]">
            The transfer case and differentials require precise calibration and
            maintenance. Contaminated fluid or leaking seals that can lead to
            major failures. Our technicians diagnose and resolve issues with
            OEM-grade parts to ensure reliable performance.
          </p>

          <div className="flex justtify-center items-center  lg:px-[5%] py-3  sm:px-2 ">
            <div className="text-black text-center  h-[100%]  ">
              {/* first */}
              <div className=" flex lg:flex-row md:flex-col flex-col w-full max-h-[50%] lg:my-[4%] md:my-[4%] my-0 justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] w-full lg:mb-0 mb-2 ">
                  <img
                    src={transfercase3}
                    alt=""
                    className="rounded-[4%] border-none outline-none box-s lg:w-[31rem]   lg:h-[22rem] md:h-[93%] h-[17rem]  w-full object-cover  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center min-h-[30%] my-auto lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl  ">
                    <b>
                      Leaks Point to{" "}
                      <span className="text-[#2772AD]">Trouble </span>
                    </b>
                  </p>
                  <p className="lg:font-normal text-gray-700  text-[1.24rem]">
                    Fluid leaks are not just messy they are early signs of worn
                    gaskets, or cracked hoses, and damaged seals. Ignoring them
                    can lead to overheating, transmission failure, or brake
                    system issues. That spotting leaks early allows for quick
                    repairs, preventing serious damage and keeping your vehicle
                    safe, efficient, and on the road longer.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 text-[1.3rem] border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
              {/* second */}
              <div className=" flex lg:flex-row md:flex-col-reverse flex-col-reverse w-full min-h-[30%] lg:my-[6%] my-[5%] justify-between   ">
                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] text-3xl   ">
                    <b>
                      4WD Engagement{" "}
                      <span className="text-[#2772AD]">Trouble</span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    If your 4WD won’t engage properly or feels delayed, it could
                    point to a failing transfer case. This critical component
                    distributes power between front and rear axles—essential for
                    traction in tough conditions. Timely inspection and
                    servicing prevent drivetrain damage and ensure your 4WD
                    system stays responsive and reliable when you need .
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2    flex justify-end">
                  <img
                    src={transfercase1}
                    alt=""
                    className="rounded-[4%]   lg:w-[31.5rem] lg:h-[22rem] md:h-[93%] h-[17rem] object-fill"
                  />
                </div>
              </div>
              {/* third */}
              <div className="flex lg:flex-row md:flex-col flex-col w-full min-h-[30%] my-[4%]    justify-between  ">
                <div className="lg:w-[50%] md:w-[97%] lg:mb-0 mb-2   w-full">
                  <img
                    src={transfercase4}
                    alt=""
                    className="rounded-[4%]   lg:w-[31rem]  lg:h-[22rem] md:h-[23rem] h-[17rem] w-full object-fill  "
                  />
                </div>

                <div className=" lg:text-start md:text-start sm:text-center my-auto  lg:w-[50%] md:w-[95%] w-[100%]">
                  <p className="lg:text-[2.6rem] md:text-3xl text-3xl  ">
                    <b>
                      Friction Heats{" "}
                      <span className="text-[#2772AD]">Parts </span>
                    </b>
                  </p>

                  <p className="leading-normal lg:font-normal text-gray-700    text-[1.24rem]">
                    Unusual heat in your differential or transfer case often
                    means internal parts are grinding or wearing unevenly. This
                    friction can lead to metal fatigue, fluid breakdown, and
                    system failure if left unchecked. Thermal stress testing
                    helps identify hotspots and underlying mechanical issues—so
                    you can fix them before costly damage occurs.
                    <div className="font-bold mt-2  ">
                      {" "}
                      <Link
                        to="/contact-us"
                        className="border-b-2 border-blue-600 hover:opacity-70"
                      >
                        Get in touch <span>&#x27A1;</span>
                      </Link>
                    </div>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className=" lg:font-normal lg:text-center md:text-left text-center text-[1.35rem] lg:px-[8.2%] ">
            Address any of these problems immediately to avoid large future
            repair bills. The mechanics of Vancouver Auto Parts will take care
            of any differential or transfer case from fluid change to total
            replacement.
          </p>
        </div>
      </div>
    </div>
  );
}
